<template>
  <div class="timeline-panel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'timeline-panel',
  props: {}
};
</script>

<style>
  .timeline-panel {
    width: 45%;
    float: left;
    border: 1px solid #d4d4d4;
    border-radius: 2px;
    padding: 20px;
    position: relative;
    -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
  }

  .timeline-panel.oculto {
    background-color: rgba(166, 158, 151, .2);
  }

  .timeline-panel:before {
    position: absolute;
    top: 26px;
    right: -15px;
    display: inline-block;
    border-top: 15px solid transparent;
    border-left: 14px solid rgba(0, 0, 0, 0.175);
    border-right: 0 solid rgba(0, 0, 0, 0.175);
    border-bottom: 15px solid transparent;
    content: " ";
  }

  .timeline-panel:after {
    position: absolute;
    top: 27px;
    right: -14px;
    display: inline-block;
    border-top: 14px solid transparent;
    border-left: 14px solid #fff;
    border-right: 0 solid #fff;
    border-bottom: 14px solid transparent;
    content: " ";
  }

  .timeline-panel.oculto:after {
    border-left: 14px solid rgba(0, 0, 0, 0.175);
    border-right: 0 solid rgba(0, 0, 0, 0.175);
  }

  li.timeline-inverted .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }

  li.timeline-inverted .timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }

  li.timeline-inverted .timeline-panel {
    float: right;
  }

  @media (max-width: 992px) {
    .timeline-panel {
      width: 82%
    }

    .timeline-panel {
      float: right;
    }

    .timeline-panel:before {
      border-left-width: 0;
      border-right-width: 15px;
      left: -15px;
      right: auto;
    }

    .timeline-panel:after {
      border-left-width: 0;
      border-right-width: 14px;
      left: -14px;
      right: auto;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/TimelinePanel.vue